import React from 'react';

import ProfileForm from './ProfileForm';
import iconClose from 'assets/images/icons/cross.svg';
import styles from './styles.scss';
import Notification from 'components/Notification';
import { useTranslation } from 'react-i18next';

const MemberPopup = ({ agentId, onClose, onChangeAgentId }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.PopUpOuter}>
      <div className={styles.PopUpInner}>
        <div className={styles.PopupClose} onClick={onClose}>
          <img src={iconClose} alt="" />
        </div>
        <div className={styles.PopupHeader}>
          <div className={styles.PopupTitle}>
            {agentId ? t('components.profile.employerInteraction.edit') : t('components.profile.employerInteraction.new')}
          </div>
        </div>
        <Notification />
        <div className={styles.PopupContent}>
          {agentId ?
            <ProfileForm agentId={agentId} popup onSave={onClose} />
            :
            <ProfileForm isNew popup onSave={onClose} onGoToEdit={onChangeAgentId} />
          }
        </div>
      </div>
    </div>
  );
};


export default MemberPopup;



// WEBPACK FOOTER //
// ./src/components/Profile/EmployerInteraction.js